
<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Our Events & Celebrations</h2>
        <!-- <h3>Nurturing Every Child's Unique Potential</h3> -->
        <p>
          At Innovative Vision, we believe that learning and growth extend beyond the classroom. 
          Our events are designed to celebrate our students' achievements, foster a spirit of sportsmanship,
          and strengthen our community. We organize a variety of annual events that engage both children and
          parents in a fun and supportive environment.
        </p>
      </div>

      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/eventH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>

<div class="sports-section">
  <!-- Title -->
  <div class="sports-header">
    <h2 class="sports-title">Annual Sports & Competitions</h2>
    <p class="sports-subtitle">
      We conduct two major sports-focused events each year that encourage healthy
      competition, teamwork, and a sense of accomplishment.
    </p>
  </div>

  <!-- Events -->
  <div class="sports-events">
    <!-- Event 1 -->
    <div class="sports-card">
      <img src="assets/ivimg/event1.svg" alt="Kids Marathon" class="sports-img" />
      <p class="sports-text">
        <strong>Kids' Marathon:</strong> An annual event where children participate
        in a short-distance run, promoting physical fitness, endurance, and a
        lifelong love for an active lifestyle, all in a fun and encouraging
        environment.
      </p>
    </div>

    <!-- Event 2 -->
    <div class="sports-card">
      <img src="assets/ivimg/event2.svg" alt="Interschool Football League" class="sports-img" />
      <p class="sports-text">
        <strong>Interschool Football League:</strong> A highly anticipated event
        that brings together teams from various schools for a friendly football
        competition. It's a platform for children to showcase their skills &
        learn about strategy and sportsmanship.
      </p>
    </div>
  </div> 
<!-- Annual day celebration  -->

<div class="annual-day-section">
  <div class="annual-day-container">
    <div class="annual-day-header">
      <h2 class="annual-day-title">Annual Day Celebrations</h2>
      <p class="annual-day-subtitle">
        Our Annual Day events are a highlight of the year, offering children a chance to shine on and off the stage.
      </p>
    </div>

    <div class="annual-day-content">
      <!-- Left Block -->
      <div class="annual-day-card">
        <img src="assets/ivimg/pd-22.svg" alt="Annual Day Sports" class="annual-day-img" />
        <p class="annual-day-text">
          <strong>Annual Day Sports (On Ground):</strong> A day dedicated to physical challenges and group activities where children can demonstrate the skills they've developed in their sports programs.
        </p>
      </div>

      <!-- Right Block -->
      <div class="annual-day-card">
        <img src="assets/ivimg/pd-33.svg" alt="Annual Day Stage" class="annual-day-img" />
        <p class="annual-day-text">
          <strong>Annual Day (On Stage):</strong> A spectacular event where students showcase their talents in dramatics, dance, and music through performances on stage, celebrating their creativity and expression.
        </p>
      </div>
    </div>
  </div>
</div>



 <div class="parent-events-section">
  <h2 class="parent-events-title" style="color: #825800;">
    Value-Added Support: Parent Events
  </h2>
  <p class="parent-events-text" style="color: #825800;">
    We believe in a strong partnership between the school and parents. To foster this, we organize special events and workshops for parents, covering topics such as child development, co-curricular benefits, and promoting an active and disciplined lifestyle at home. These events are designed to be a supportive and engaging experience for our parent community.
  </p>
</div>

</div>
